// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"1805a3f1","498":"2c65c4e8","703":"6bdc52c0"}[chunkId] + ".chunk.js";
};